import { useEffect, useState } from "react";
import { getModelsByBrand } from "../../../../../common/services/fipe.api";
import { getIn, useFormikContext } from "formik";
import AutocompleteFormik from "../../../../../common/components/form/AutocompleteFormik";

export function FipeModelFieldFormik() {
  const [options, setOptions] = useState([])
  const formik = useFormikContext()
  const brand = getIn(formik.values, 'fipeInfo.brand')

  useEffect(() => {
    async function load() {
      if (!brand || !brand.fipeId) {
        setOptions([])
        return
      }

      const result = await getModelsByBrand(brand.fipeId)
      if (result.ok) {
        setOptions(result.data as [])
      }
    }

    load()
  }, [brand])

  return (
    <AutocompleteFormik
      label="Modelo:"
      name="fipeInfo.model"
      valueProperty="fipeId"
      options={options}
      exactMatchOnly={false}

    />
  )
}